import { TRPCErrorBoundary } from '@client/components/_core/error-handling/TRPCErrorBoundary';
import { PageController } from '@client/components/_core/layout/PageController';
import { FieldConfigurationViewRenderer } from '@client/components/_ui/data-entry/FieldConfigurationRenderer';
import { trpc } from '@client/trpc/client';
import { skipToken } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Card, Col, Row } from 'antd';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/product-type-data')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ProductTypeData />
        </PageController>
    );
}

function ProductTypeData() {
    const claim = claimFormStore.use.formData();
    const isReadOnly = claimFormStore.use.isReadonly();

    const { data, error } = trpc.productType.getProductType.useQuery(
        claim.productTypeId ? { id: claim.productTypeId } : skipToken,
        {
            refetchOnWindowFocus: false,
        },
    );

    const cards = (data?.definition?.cards || []).filter((item) => item.type === 'FORM');

    return (
        <TRPCErrorBoundary error={error}>
            <Row gutter={[16, 16]}>
                {cards.map((item) => (
                    <Col span={12} key={item.id}>
                        <Card size="small" title={item.title} className="h-full">
                            {claim.productTypeId && (
                                <FieldConfigurationViewRenderer
                                    entity="PRODUCT_TYPE"
                                    entityId={claim.productTypeId}
                                    section={item.id}
                                    fieldPathPrefix="productTypeCustomFieldsData"
                                    formStore={claimFormStore}
                                    isReadOnly={isReadOnly}
                                    layout={{
                                        wrapInRow: true,
                                    }}
                                />
                            )}
                        </Card>
                    </Col>
                ))}
            </Row>
        </TRPCErrorBoundary>
    );
}
